import type { ThemeV3 } from '../types/themeTypes';

export const lapisTheme: ThemeV3 = {
  id: 'Lapis',
  name: 'Lapis',
  version: 3,
  mode: 'light',
  colorTokens: {
    'surface-0': 'oklch(93.66% 0.0113 250)',
    'surface-1':
      'color-mix(in srgb, var(--color-surface-0) 38%, var(--color-surface-4))',
    'surface-2':
      'color-mix(in srgb, var(--color-surface-0) 24%, var(--color-surface-4))',
    'surface-3':
      'color-mix(in srgb, var(--color-surface-0) 10%, var(--color-surface-4))',
    'surface-4': 'oklch(1 0 250deg)',
    'content-0': 'oklch(0.23 0.018 250deg)',
    'content-1': 'oklch(0.4 0.016 250deg)',
    'content-2':
      'color-mix(in srgb, var(--color-content-0) 51%, var(--color-content-4))',
    'content-3': 'oklch(0.62 0.012 250deg)',
    'content-4': 'oklch(70.26% 0.0412 250)',
    edge: 'oklch(93% 0.01 250 / 0)',
    'edge-muted': 'oklch(95% 0.008 250 / 0)',
    accent: 'oklch(67.41% 0.1964 255)',
    red: 'oklch(56.77% 0.2102 27.67)',
    orange: 'oklch(72.22% 0.1679 47.6)',
    amber: 'oklch(74.91% 0.1462 70.08)',
    yellow: 'oklch(84.36% 0.1931 86.05)',
    lime: 'oklch(79.88% 0.1645 130.9)',
    green: 'oklch(68.03% 0.1701 149.6)',
    teal: 'oklch(72.82% 0.1729 182.5)',
    cyan: 'oklch(69.5% 0.1452 215.2)',
    blue: 'oklch(0.55 0.17 259.815deg)',
    violet: 'oklch(0.55 0.17 292.717deg)',
    purple: 'oklch(0.55 0.17 303.9deg)',
    pink: 'oklch(0.55 0.17 354.308deg)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    lift: 'var(--layer-lift)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'oklch(72.47% 0.2016 286)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-lift)',
    message: 'var(--color-lift)',
    hover:
      'color-mix(in oklch, color-mix(in oklch, var(--color-content-0) 50%, var(--color-accent)) 3%, transparent)',
    active:
      'color-mix(in oklch, color-mix(in oklch, var(--color-content-0) 50%, var(--color-accent)) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-yellow)',
    failure: 'var(--color-red)',
    chrome: 'var(--color-surface-4)',
  },
};
